import { IModuleRoute, RoleTypes, AppRouteNamesList } from 'models';

const nexusRequiredRoles = [
	RoleTypes.PRIMARY_ADMIN,
	RoleTypes.ADMIN,
	RoleTypes.CLIENT_USER,
	RoleTypes.PARTNER_USER,
];

export enum NexusPathList {
	nexus = '/nexus',
	/* The capability drill-down, keyed on the REGISTRY ID.

	   This is the first addressable Nexus URL, and it is addressable because
	   `family_id` finally exists — 11/11 Tyrell rows and 17/17 LawCo. It is
	   not keyed on the family's display name, which is the tenant's own
	   vocabulary and re-authorable; a link built from that would rot on the
	   first curation pass and only for whoever had saved it. */
	capability = '/nexus/capability/:familyId',
}

/* Nexus IS the app root since the shell split (Steve, 2026-08-11): no
   `/admin` prefix. The old `/admin/nexus…` URLs stay alive as redirects in
   src/router/index.tsx — capability URLs are addressable by design, so
   saved links must not rot. */
export const nexusRoutes: IModuleRoute = {
	path: NexusPathList.nexus,
	name: AppRouteNamesList.nexus,
	requiredRoles: nexusRequiredRoles,
	nested: [
		{
			path: NexusPathList.capability,
			name: AppRouteNamesList.nexus,
			requiredRoles: nexusRequiredRoles,
		},
	],
};

export const capabilityPath = (familyId: string): string =>
	NexusPathList.capability.replace(':familyId', encodeURIComponent(familyId));

/* Where the capability page's back button returns to. BillboardTable — the
   only place a reader can reach the capability page from — renders
   exclusively on the Service performance tab, so "back" always means that
   tab and never the default. Pulled out as its own function because the
   one time this was inlined as `nexusRoutes.path` with no query string, the
   back button silently landed the reader on Executive summary instead of
   where they had drilled in from — a defect a template string is cheap to
   pin against, unlike the full connected page it lives in. */
export const capabilityBackPath = (): string =>
	`${nexusRoutes.path}?tab=performance`;
